<template>
  <a :href="getUrl(post.slug)" class="block rounded-lg bg-grey-light overflow-hidden shadow-card relative">
    <div class="is-fixed-ar is-3x2">
      <div class="ar-inside">
        <img v-if="post.thumbnail" :src="post.thumbnail.urls.wide_403" :alt="altText" class="full-bg-cover" />
      </div>
    </div>
    <p class="w-full bg-white px-5 pb-6 pt-4.5 font-primary font-extrabold text-20 leading-1.2 min-h-90">{{ post.title }}</p>
  </a>
</template>

<script>
import Route from '../src/Route';
import get from 'lodash/get';

export default {
  props: {
    post: {
      required: true,
      type: Object,
    },
  },

  computed: {
    imageUrl() {
      return get(this.post, 'thumbnail.url');
    },

    altText() {
      return get(this.post, 'thumbnail.alt_text');
    },
  },

  methods: {
    getUrl(slug) {
      return Route('posts.show', {post: slug});
    },
  },
}
</script>
